// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&family=Open+Sans&family=Lobster&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-loading-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  grid-auto-rows: 100px;
  grid-template-areas:
    ". a a ."
    ". a a .";
}
.App-loading-item {
  grid-area: a;
  align-self: center;
  justify-self: center;
  width: 200px;
}
.App-loading-item span {
  display: block;
  text-align: center;
  font-size: 15px;
  margin-bottom: 20px;
}

.auth-loading-shell {
  min-height: 55vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0 12px 18px;
}

.auth-loading-card {
  width: min(460px, 100%);
  background: linear-gradient(180deg, #ffffff 0%, #f7faf7 100%);
  border: 1px solid #e5ece5;
  border-radius: 10px;
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.08);
  padding: 26px 16px;
  text-align: center;
  margin-top: 30px;
}

.auth-loading-spinner {
  width: 42px;
  height: 42px;
  margin: 0 auto 20px;
  border-radius: 50%;
  border: 3px solid #d1fae5;
  border-top-color: #166534;
  animation: auth-spin 0.9s linear infinite;
}

.auth-loading-title {
  margin: 0;
  font-size: 16px;
  line-height: 1.2;
  color: #1f2937;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
}

.auth-loading-subtitle {
  margin-top: 4px;
  color: #4b5563;
  font-size: 12px;
}

@keyframes auth-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.auth-error-shell {
  min-height: 55vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 36px 12px 24px;
}

.auth-error-card {
  width: min(760px, 100%);
  background: #ffffff;
  border: 1px solid #e6e8ec;
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.08);
  padding: 22px 24px;
}

.auth-error-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #8a2a16;
  background: #fff1ed;
  border: 1px solid #ffd4c7;
  border-radius: 999px;
  padding: 4px 10px;
}

.auth-error-title {
  margin: 12px 0 10px;
  font-size: 26px;
  line-height: 1.2;
  color: #1f2937;
  font-family: "Open Sans", sans-serif;
}

.auth-error-message {
  margin: 0;
  color: #374151;
  font-size: 15px;
  line-height: 1.6;
}

.auth-error-steps {
  margin: 14px 0 0 18px;
  color: #374151;
  font-size: 14px;
  line-height: 1.6;
}

.auth-error-actions {
  margin-top: 18px;
}

.auth-error-btn {
  border: 0;
  border-radius: 6px;
  padding: 10px 14px;
  background: #166534;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.auth-error-btn:hover {
  background: #14532d;
}

.emergency-maintenance-shell {
  min-height: 100vh;
  background: #eceff1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
}

.emergency-maintenance-card {
  width: min(1040px, 100%);
  background: #ffffff;
  border: 1px solid #cfd4d8;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
  padding: 56px 44px 50px;
  text-align: center;
}

.emergency-maintenance-title {
  margin: 0 0 30px;
  color: #1f6a5a;
  font-size: clamp(26px, 2.4vw, 40px);
  line-height: 1.15;
  font-weight: 700;
  font-family: "Open Sans", sans-serif;
}

.emergency-maintenance-body {
  margin: 0 auto;
  max-width: 900px;
  color: #374151;
  font-size: clamp(16px, 1.3vw, 24px);
  line-height: 1.6;
  font-family: "Roboto", sans-serif;
}

.emergency-maintenance-line {
  margin: 0 0 12px;
}

.emergency-maintenance-line-muted {
  font-size: 0.86em;
}

.emergency-maintenance-line-last {
  margin-top: 22px;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB;;aAEW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto&family=Open+Sans&family=Lobster&display=swap');\r\n\r\n.App-loading-wrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 10px;\r\n  grid-auto-rows: 100px;\r\n  grid-template-areas:\r\n    \". a a .\"\r\n    \". a a .\";\r\n}\r\n.App-loading-item {\r\n  grid-area: a;\r\n  align-self: center;\r\n  justify-self: center;\r\n  width: 200px;\r\n}\r\n.App-loading-item span {\r\n  display: block;\r\n  text-align: center;\r\n  font-size: 15px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.auth-loading-shell {\r\n  min-height: 55vh;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  padding: 0 12px 18px;\r\n}\r\n\r\n.auth-loading-card {\r\n  width: min(460px, 100%);\r\n  background: linear-gradient(180deg, #ffffff 0%, #f7faf7 100%);\r\n  border: 1px solid #e5ece5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.08);\r\n  padding: 26px 16px;\r\n  text-align: center;\r\n  margin-top: 30px;\r\n}\r\n\r\n.auth-loading-spinner {\r\n  width: 42px;\r\n  height: 42px;\r\n  margin: 0 auto 20px;\r\n  border-radius: 50%;\r\n  border: 3px solid #d1fae5;\r\n  border-top-color: #166534;\r\n  animation: auth-spin 0.9s linear infinite;\r\n}\r\n\r\n.auth-loading-title {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  line-height: 1.2;\r\n  color: #1f2937;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.auth-loading-subtitle {\r\n  margin-top: 4px;\r\n  color: #4b5563;\r\n  font-size: 12px;\r\n}\r\n\r\n@keyframes auth-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.auth-error-shell {\r\n  min-height: 55vh;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  padding: 36px 12px 24px;\r\n}\r\n\r\n.auth-error-card {\r\n  width: min(760px, 100%);\r\n  background: #ffffff;\r\n  border: 1px solid #e6e8ec;\r\n  border-radius: 14px;\r\n  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.08);\r\n  padding: 22px 24px;\r\n}\r\n\r\n.auth-error-badge {\r\n  display: inline-block;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  color: #8a2a16;\r\n  background: #fff1ed;\r\n  border: 1px solid #ffd4c7;\r\n  border-radius: 999px;\r\n  padding: 4px 10px;\r\n}\r\n\r\n.auth-error-title {\r\n  margin: 12px 0 10px;\r\n  font-size: 26px;\r\n  line-height: 1.2;\r\n  color: #1f2937;\r\n  font-family: \"Open Sans\", sans-serif;\r\n}\r\n\r\n.auth-error-message {\r\n  margin: 0;\r\n  color: #374151;\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.auth-error-steps {\r\n  margin: 14px 0 0 18px;\r\n  color: #374151;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.auth-error-actions {\r\n  margin-top: 18px;\r\n}\r\n\r\n.auth-error-btn {\r\n  border: 0;\r\n  border-radius: 6px;\r\n  padding: 10px 14px;\r\n  background: #166534;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.auth-error-btn:hover {\n  background: #14532d;\n}\n\n.emergency-maintenance-shell {\n  min-height: 100vh;\n  background: #eceff1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n}\n\n.emergency-maintenance-card {\n  width: min(1040px, 100%);\n  background: #ffffff;\n  border: 1px solid #cfd4d8;\n  border-radius: 14px;\n  box-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);\n  padding: 56px 44px 50px;\n  text-align: center;\n}\n\n.emergency-maintenance-title {\n  margin: 0 0 30px;\n  color: #1f6a5a;\n  font-size: clamp(26px, 2.4vw, 40px);\n  line-height: 1.15;\n  font-weight: 700;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.emergency-maintenance-body {\n  margin: 0 auto;\n  max-width: 900px;\n  color: #374151;\n  font-size: clamp(16px, 1.3vw, 24px);\n  line-height: 1.6;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.emergency-maintenance-line {\n  margin: 0 0 12px;\n}\n\n.emergency-maintenance-line-muted {\n  font-size: 0.86em;\n}\n\n.emergency-maintenance-line-last {\n  margin-top: 22px;\n}\n\n.App {\n  text-align: center;\n}\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
